









































import { Component, Prop, Vue } from 'vue-property-decorator';

import InfoIcon from '@/components/icons/Info.vue';

import {
  EInitiativesDictionary,
  InitiativeThemeDictionary
} from '@/models/initiatives';

type Size = 'sm' | 'md';

@Component({
  components: {
    InfoIcon
  }
})
export default class FilterTag extends Vue {
  @Prop(String) label!: string;
  @Prop({ default: 'button' }) as?: string;
  @Prop({ default: false }) isActive?: boolean;
  @Prop({ default: EInitiativesDictionary.DEFAULT })
  theme?: EInitiativesDictionary;
  @Prop({ default: 'md' }) size?: Size;
  @Prop({ default: false }) viewOnly?: boolean;
  @Prop({ default: false }) unmargin?: boolean;
  @Prop({ default: '' }) tooltipText?: string;

  get themeConfig() {
    return InitiativeThemeDictionary;
  }

  get themeStyle() {
    if (!this.theme || !this.themeConfig[this.theme]) return {};

    const { color, bg, activeBg, activeColor } = this.themeConfig[this.theme];

    return {
      '--tag-color': color,
      '--tag-bg': bg,
      '--tag-active-bg': activeBg,
      '--tag-active-color': activeColor
    };
  }
}
